import script from "./NinthSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./NinthSection.vue?vue&type=script&setup=true&lang=ts"

import "./NinthSection.vue?vue&type=style&index=0&id=73a18338&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73a18338"]])

export default __exports__